<template>
    <li class="z-timeline-item" :class="`z-timeline-item--${theme}`">
        <z-icon
            class="z-timeline-item__icon"
            :class="{'z-timeline-item__icon--empty': !icon}"
            :name="getIcon"
            :width="24"
            :height="24"
        />

        <div class="z-timeline-item__content">
            <div v-if="title" class="z-timeline-item__title">{{ title }}</div>
            <p v-if="text" class="z-timeline-item__text">
                <vue-raw :raw="text"/>
            </p>
        </div>
    </li>
</template>

<script setup>
import {computed, inject} from 'vue'

const theme = inject('theme')
const props = defineProps({
    icon: {
        type: String,
        default: ''
    },
    title: String,
    text: String,
})

const getIcon = computed(() => {
    return props.icon ? props.icon : 'list/dot'
})
</script>

<style lang="scss">
.z-timeline-item{
    position: relative;
    padding-left: 16px;
    padding-bottom: 56px;
    display: flex;
    @include gap-level(2XL);

    @include breakpoint(v-tablet){
        @include gap-level(S);
    }

    &:before{
        content: '';
        position: absolute;
        top: 0;
        left: 38px;
        width: 2px;
        height: 100%;
        opacity: 0.3;
        background: var(--base-black-black-20, #E3EEEB);

        @include breakpoint(v-tablet){
           left: 36px;
        }
    }

    &:first-of-type{
        &:before{
            top: 7px;
            height: calc(100% - 7px);
        }
    }

    &:last-of-type{
        &:before{
            height: 7px;
        }
    }

    &__icon{
        margin-top: 7px;
        padding: 2px;
        min-width: 46px;
        max-width: 46px;
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: var(--color-black-5);

        @include breakpoint(v-tablet){
            padding: 12px;
            min-width: 42px;
            max-width: 42px;
            height: 42px;
        }

        &--empty{
            padding: 10px;
            background: var(--color-white);
        }
    }

    &__content {
        padding: var(--spacer-m);
        width: 100%;
        border-radius: 16px;
        background: var(--color-primary);
    }

    &__title {
        @include margin-level(bottom, S);
        font-size: var(--typography-lt);
        font-weight: 500;
        line-height: 120%;
        color: var( --color-white);
    }

    &__text{
        @include typo-level(L);
        font-weight: 400;
        line-height: 130%;
        color: var(--color-white);
    }

    &--timeline-horizontal {
        flex: 1 1;
        padding: 0 var(--spacer-s) 0 0;
        max-width: 600px;
        flex-direction: column;
        @include gap-level(XS);

        @include breakpoint(mobile){
            max-width: calc(100vw - $token-grids-mobile-offset * 2);
        }

        &:before{
            top: 33px;
            left: 0;
            width: 100%;
            height: 2px;

            @include breakpoint(v-tablet){
                top: 27px;
            }
        }
        &:first-of-type{
            &:before{
                top: 33px;
                width: 100%;
                height: 2px;
                @include breakpoint(v-tablet){
                    top: 27px;
                }
            }
        }
        &:last-of-type{
            &:before{
                height: 2px;
            }
        }
    }
}
body.green {
    .z-timeline-item {
        &__content {
            padding: var(--spacer-xs) var(--spacer-m);
            border: 1px solid rgba(255, 255, 255, 0.32);
            background: rgba(255, 255, 255, 0.23);
        }

        &__title {
            margin-bottom: var(--spacer-2xs);
        }

        &__icon {
            background: #3D8C7F;
            border: 1px solid #FFFFFF52;

            & path {
                fill: var(--color-white);
            }
        }
    }
}
</style>
